(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/views/favorite-button.js') >= 0) return;  svs.modules.push('/components/sport/favorites/views/favorite-button.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.favorites=_svs.sport.favorites||{};
_svs.sport.favorites.templates=_svs.sport.favorites.templates||{};
svs.sport.favorites.templates.favorite_button = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "-empty";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<i class=\"js-favorite-icon 2 icon-200 icon-star"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.hasFavorites : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " icon-default\"></i>\n";
},"useData":true});
Handlebars.partials['components-sport-favorites-favorite_button'] = svs.sport.favorites.templates.favorite_button;
})(svs, Handlebars);

 })(window);